/* 
Generated code: do not modify this file as it will be overwritten
Template: ImmutableJSRecord.cst

Known Issues/TODO:
- Using *Props type as Record constructor parameter is insufficient.
If a property needs to be a Record type, it should already be constructed.
- Rename Record fromJS factory method to fromJSON
- Create parseJSON method that translates JSON to Props



 */

/* eslint-disable import/order */

import { createSelector } from '@ngrx/store';
import { List, Map, Record, Seq, Set } from 'immutable';
import {
  IdListItemRecord,
  IdListItemProps,
} from 'src/store/generated/id-list-item-record.generated';
import { AppState } from 'src/store/appstate';
import { getFromOrThrow, propValueOrDefault, tryOrDefault } from 'src/util/values';

export interface CrewSourcedUnitProps {
  id: string;
  unitPositions: List<IdListItemProps>;
}

export class CrewSourcedUnitRecord extends Record<CrewSourcedUnitProps>({
  id: null as any,
  unitPositions: null as any,
}) {
  public static fromJS(json: { id: string; unitPositions: any }): CrewSourcedUnitRecord {
    if (json == null) {
      throw new Error('CrewSourcedUnitRecord.fromJS: parameter cannot be null');
    }
    return new CrewSourcedUnitRecord({
      id: getFromOrThrow(
        json,
        (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
        'CrewSourcedUnitJson.id',
      ),
      unitPositions: List<IdListItemRecord>(
        getFromOrThrow(json, (j) => j.unitPositions, 'CrewSourcedUnitJson.unitPositions').map(
          (o: any) => new IdListItemRecord(o),
        ),
      ),
    });
  }

  public static fromJSUnsafe(json: {
    id: string;
    unitPositions: any;
  }): [CrewSourcedUnitRecord, Error[]] {
    if (json == null) {
      throw new Error('CrewSourcedUnitRecord.fromJSUnsafe: parameter cannot be null');
    }
    const errors: Error[] = [];

    const record = new CrewSourcedUnitRecord({
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      id: tryOrDefault(
        () =>
          getFromOrThrow(
            json,
            (j) => propValueOrDefault(j, 'id', '00000000-0000-0000-0000-000000000000'),
            'CrewSourcedUnitJson.id',
          ),
        (err) => errors.push(err),
      )!,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      unitPositions: tryOrDefault(
        () =>
          List<IdListItemRecord>(
            getFromOrThrow(json, (j) => j.unitPositions, 'CrewSourcedUnitJson.unitPositions').map(
              (o: any) => new IdListItemRecord(o),
            ),
          ),
        (err) => errors.push(err),
      )!,
    });

    return [record, errors];
  }

  constructor(props: CrewSourcedUnitProps) {
    super(props);
    if (props == null) {
      throw new Error('CrewSourcedUnitRecord constructor parameter cannot be null');
    }
  }
}

export abstract class CrewSourcedUnitViewModelBase implements CrewSourcedUnitProps {
  protected readonly _props: CrewSourcedUnitProps;
  private _json?: CrewSourcedUnitProps;

  get id(): string {
    return this._props.id;
  }
  get unitPositions(): List<IdListItemProps> {
    return this._props.unitPositions;
  }

  constructor(props: CrewSourcedUnitProps) {
    this._props = props;
  }

  public toJS() {
    return this.toJSON();
  }

  public toJSON() {
    if (this._json == null) {
      this._json = {
        id: this._props.id,
        unitPositions: this._props.unitPositions,
      };
    }
    return this._json;
  }
}
